import { Component, Input } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'arrow-right-icon',
  /* eslint-disable */
  template: `
    <div class='arrow-right-icon' style='transform: rotate(-90deg)'>
      <svg width="10px" height="10px" viewBox="0 0 10 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <!-- Generator: Sketch 49.1 (51147) - http://www.bohemiancoding.com/sketch -->
          <g id="Import-/-Export-Managers" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g class='icon' id="Export-Manager---Receivers-Modal" transform="translate(-966.000000, -280.000000)" fill="#00C0FA">
                  <g id="Receivers-sent-to">
                      <g id="Modal" transform="translate(244.000000, 60.000000)">
                          <g id="List" transform="translate(1.000000, 0.000000)">
                              <g id="Button" transform="translate(660.000000, 212.000000)">
                                  <polygon id="Icon" points="71.0352143 13.0359214 67.4487343 13.0359214 67.4487343 7.96478574 64.62028 7.96478574 64.62028 13.0359214 61.0352143 13.0359214 66.0345071 18.0352143"></polygon>
                              </g>
                          </g>
                      </g>
                  </g>
              </g>
          </g>
      </svg>
    </div>
  `,
  /* eslint-enable */
})
export class ArrowRightIconComponent {

}
